<ngx-spinner [name]="'relatorio-vendas'" type="ball-clip-rotate-pulse" [fullScreen]="false"
    bdColor="rgba(0, 0, 0, 0.2)"></ngx-spinner>
<mat-card>
    <mat-card-header>
        <mat-card-title>Relatório de vendas</mat-card-title>
    </mat-card-header>
    <mat-divider></mat-divider>

    <mat-card-content>

        <div class="row">
            <div class="col-auto">
                <mat-form-field class="example-full-width" appearance="fill">
                    <mat-label>Período</mat-label>
                    <mat-date-range-input [formGroup]="range" [rangePicker]="picker" [max]="maxDate" [min]="minDate"
                        disabled>
                        <input matStartDate formControlName="start" placeholder="Início">
                        <input matEndDate formControlName="end" placeholder="Fim">
                    </mat-date-range-input>
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-date-range-picker #picker disabled="false"></mat-date-range-picker>

                    <mat-error *ngIf="range.controls.start.hasError('matStartDateInvalid')">Data inicial inválida
                    </mat-error>
                    <mat-error *ngIf="range.controls.end.hasError('matEndDateInvalid')">Data final inválida</mat-error>
                </mat-form-field>
            </div>

            <div class="col-2">
                <mat-form-field appearance="fill" [floatLabel]="'always'">
                    <mat-label>Status do pedido</mat-label>
                    <mat-select [(ngModel)]="sBuscaStatusPedido">
                        <mat-option *ngFor="let tipo of aTiposBuscaStatusPedido" [value]="tipo.value">
                            {{tipo.name}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div class="col-2">
                <mat-form-field appearance="fill" [floatLabel]="'always'">
                    <mat-label>Status do pagamento</mat-label>
                    <mat-select [(ngModel)]="sBuscaStatusPagamento">
                        <mat-option *ngFor="let tipo of aTiposStatusPagamento" [value]="tipo.value">
                            {{tipo.name}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div class="col-2">
                <mat-form-field appearance="fill" [floatLabel]="'always'">
                    <mat-label>Vendedor</mat-label>
                    <mat-select [(ngModel)]="sBuscaVendedor" required
                        [disabled]="tipoCadastro === 'Vendedor' ? true : false">
                        <mat-option *ngFor="let vendedor of aVendedores" [value]="vendedor.value">
                            {{vendedor.name}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div class="col-6">
                <mat-form-field appearance="outline" [floatLabel]="'always'" >
                    <mat-label>Produto</mat-label>
                    <input type="text" matInput [(ngModel)]="sBuscaProduto" maxlength="100"
                        (keypress)="omit_special_char($event)" [matAutocomplete]="auto"
                        (ngModelChange)="onChangeNomeProduto($event)" [disabled]="tipoCadastro === 'Vendedor' ? true : false">
                    <mat-hint *ngIf="bCaracterEspecial" align="start" style="color: red;"> Não são permitidos
                        acentos ou
                        caracteres especiais </mat-hint>
                </mat-form-field>
                <mat-autocomplete #auto="matAutocomplete">
                    <mat-option *ngFor="let prod of aProdutosFiltrados" [value]="prod.name"
                        (onSelectionChange)="selecionarProduto(prod.value)">
                        {{prod.name}}
                    </mat-option>
                </mat-autocomplete>


                <!-- <mat-form-field appearance="fill" [floatLabel]="'always'">
                    <mat-label>Produto</mat-label>
                    <mat-select [(ngModel)]="sBuscaProduto" required
                        [disabled]="tipoCadastro === 'Vendedor' ? true : false">
                        <input matInput (keyup)="aplicarFiltroProdutos($event)" placeholder="Busca por nome">

                        <mat-option *ngFor="let produto of aProdutosFiltrados" [value]="produto.value">
                            {{produto.name}}
                        </mat-option>
                    </mat-select>
                    <mat-hint align="end">Ao informar produto diferente de "Todos", o relatório será somente sobre o
                        produto selecionado</mat-hint>
                </mat-form-field> -->
            </div>

            <div class="col-1">
                <mat-form-field appearance="fill" [floatLabel]="'always'">
                    <mat-label>UF</mat-label>
                    <mat-select [(ngModel)]="sBuscaUF" (ngModelChange)="carregarCidades()">
                        <mat-option *ngFor="let tipo of aUFs" [value]="tipo.value">
                            {{tipo.name}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div class="col-2">
                <mat-form-field appearance="fill" [floatLabel]="'always'">
                    <mat-label>Cidade</mat-label>
                    <mat-select [(ngModel)]="sBuscaCidade">
                        <mat-option *ngFor="let tipo of aCidades" [value]="tipo.value">
                            {{tipo.name}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div class="col-2">
                <button class="mt-4" mat-flat-button color="primary" (click)="buscarVendasPeriodo()">
                    <mat-icon>search</mat-icon> Buscar
                </button>
            </div>
        </div>

        <div class="row mt-4" *ngIf="bConsulta">
            <div class="col-sm">
                <mat-divider></mat-divider>

                <div class="row mt-2">
                    <div class="col-sm text-right">
                        <button mat-flat-button color="warn" (click)="exportar()">
                            <mat-icon>print</mat-icon> Exportar relatório vendas
                        </button>
                    </div>
                    <div class="col-auto">
                        <button mat-flat-button color="warn" (click)="exportarRelatorioProdutos()">
                            <mat-icon>print</mat-icon> Exportar relatório produto
                        </button>
                    </div>
                </div>

                <div class="row mt-4">
                    <div class="col-auto">
                        <div class="borda">
                            <div style="margin: 16px;">
                                <div class="titulo">Por status do pedido</div>
                                <div>
                                    <div class="preContador">Confirmados:</div> {{contConfirmados}}
                                </div>
                                <div>
                                    <div class="preContador">Em separação:</div> {{contEmSeparacao}}
                                </div>
                                <div>
                                    <div class="preContador">Em rota:</div> {{contEmRota}}
                                </div>
                                <div>
                                    <div class="preContador">Entregues:</div> {{contEntregues}}
                                </div>
                                <div>
                                    <div class="preContador">Cancelados:</div> {{contCancelados}}
                                </div>
                                <div>
                                    <div class="preContador">Total de pedidos no período:</div> {{contConfirmados +
                                    contEmSeparacao + contEmRota +
                                    contEntregues + contCancelados}}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-auto">
                        <div class="borda">

                            <div style="margin: 16px;">
                                <div class="titulo">Por status do pagamento</div>
                                <div>
                                    <div class="preContador">Pendente:</div> {{contPagamentoPendente}}
                                </div>
                                <div>
                                    <div class="preContador">Confirmado:</div> {{contPagamentoConfirmado}}
                                </div>
                                <div>
                                    <div class="preContador">Cancelado:</div> {{contPagamentoCancelado}}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-auto">
                        <div class="borda">

                            <div style="margin: 16px;">
                                <div class="titulo">Por forma de pagamento</div>
                                <div>
                                    <div class="preContador">Boleto:</div> {{contPagamentoBoleto}}
                                </div>
                                <div>
                                    <div class="preContador">Crédito:</div> {{contPagamentoCredito}}
                                </div>
                                <div>
                                    <div class="preContador">Débito:</div> {{contPagamentoDebito}}
                                </div>
                                <div>
                                    <div class="preContador">Dinheiro:</div> {{contPagamentDinheiro}}
                                </div>
                            </div>
                        </div>
                    </div>


                    <div class="col-auto">
                        <div class="borda">
                            <div style="margin: 16px;">
                                <div class="preContador">Total</div>
                                <div style="font-weight: bold;"> R$
                                    {{somaTotal.toFixed(2).replace('.',',')}}</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row mt-4" *ngIf="sBuscaStatusPedido === 'Todos'">
                    <div class="col-sm">
                        <div style="color: gray; font-size: small;">* Pedidos cancelados aparecem na exportação mas não
                            são contabilizados no total</div>
                    </div>
                </div>
            </div>
        </div>
    </mat-card-content>
</mat-card>